<template>
    <div id="page-content-wrapper" class="admin-content-area">       
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name color-71aa3f">
                        Task Information <span class="badge badge-info">{{ formatString(customerArr[0].status)}}</span>
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backShowTask">Back</button>
                </div>
                <div class="admin-page-content">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <b-list-group>
                                <template v-for="(customerData , key) in customerArr">
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Customer Name : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.first_name}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Subject : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.subject}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Description : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.description}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Created By : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.created_user_firstname + " " + customerData.created_user_lastname}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                </template>
                            </b-list-group>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <b-list-group>
                                <template v-for="(customerData , key) in customerArr">
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Date : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{formatDate(customerData.due_date)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Priority : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{formatString(customerData.priority)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Assign To : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.user_firstname + " " + customerData.user_lastname}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                </template>
                            </b-list-group>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>   
</template>
<script>
    import Vue from 'vue';
    import FrontFooter from '@/components/partials/FrontFooter';
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';
    export default {
        name: 'TaskView',
        components: {
            'app-footer': FrontFooter,
        },
        mixins: [SessioMixin],
        data() {
            return{
                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,
                customerArr: [[]],
                commentsArr: [],
                comment: '',
                editId: ''
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            $(".removeActive").removeClass('active');
            if (segments[4] != 0) {
                $("#menucustomers").addClass("active");
            } else {
                $("#menutasks").addClass('active');
            }
            var self = this;
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            self.showLoader();
            self.loadTask();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_task_view') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            loadTask() {

                var path = window.location.pathname;
                var segments = path.split("/");
                // console.log(segments[3]);
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/task/" + segments[3],
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        // console.log(data.code);
                        self.customerArr = data.content;

                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            backShowTask() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[4] != 0) {
                    self.$router.push("/customer/view/" + segments[4]);
                } else {
                    self.$router.push('/task/list');
                }
            },
            formatString(data) {
                if (typeof (data) != 'undefined') {
                    var self = this;
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                } else {
                    return false;
                }
            },
            formatDate(date) {
                if (typeof (date) != 'undefined') {
                    date = date.split(" ");
                    date = date[0];
                    var d = new Date(date);
                    var month = '' + (d.getMonth() + 1);
                    var day = '' + d.getDate();
                    var year = d.getFullYear();
                    if (month.length < 2)
                        month = '0' + month;
                    if (day.length < 2)
                        day = '0' + day;
                    return [month, day, year].join('/');
                } else {
                    return false;
                }
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/task/TaskView.vue